(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var openBtn = document.querySelector('[data-mobile-menu-open]');
  var closeBtn = document.querySelector('[data-mobile-menu-close]');
  function toggleMobileMenu(open) {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
  }
  if (openBtn) openBtn.addEventListener('click', function () { toggleMobileMenu(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { toggleMobileMenu(false); });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-faq-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-faq-trigger]');
    var panel = item.querySelector('[data-faq-panel]');
    if (!trigger || !panel) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var decrease = e.target.closest('[data-qty-decrease]');
    var increase = e.target.closest('[data-qty-increase]');
    if (!decrease && !increase) return;
    var wrap = (decrease || increase).closest('.qty-stepper');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    if (decrease) value = Math.max(min, value - 1);
    if (increase) value = value + 1;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart line quantity persistence ---------- */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-line-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var line = removeBtn.closest('[data-line-item]');
    var input = line && line.querySelector('[data-qty-input]');
    if (!input) return;
    input.value = 0;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var line = input.closest('[data-line-item]');
    if (!line) return; // not a cart line (e.g. product form quantity)
    var lineIndex = parseInt(line.getAttribute('data-line-item'), 10);
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    var inDrawer = !!line.closest('[data-cart-drawer]');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (inDrawer) {
          refreshCart();
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) { console.error('Cart update failed', err); });
  });

  /* ---------- Banner carousel ---------- */
  document.querySelectorAll('[data-banner-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-banner-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-banner-dot]'));
    var prevBtn = slider.querySelector('[data-banner-prev]');
    var nextBtn = slider.querySelector('[data-banner-next]');
    if (slides.length < 2) return;
    var index = 0;
    var autoplayId;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, di) { dot.classList.toggle('is-active', di === index); });
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }
    function startAutoplay() {
      stopAutoplay();
      autoplayId = setInterval(next, 5000);
    }
    function stopAutoplay() {
      if (autoplayId) clearInterval(autoplayId);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, di) {
      dot.addEventListener('click', function () { goTo(di); startAutoplay(); });
    });
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  });

  /* ---------- Product image thumbnails ---------- */
  var productThumbs = document.querySelectorAll('[data-thumb]');
  productThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('#ProductMainImage img');
      if (mainImg) mainImg.src = thumb.getAttribute('data-image');
      productThumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Product variant selection ---------- */
  var productForm = document.querySelector('#ProductForm');
  if (productForm) {
    var variantsScript = document.querySelector('#ProductVariants');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantSelect = productForm.querySelector('[data-variant-select]');
    var optionSelectors = productForm.querySelectorAll('[data-option-selector]');

    function currentOptions() {
      var groups = {};
      optionSelectors.forEach(function (input) {
        if (input.checked) groups[input.name] = input.value;
      });
      return Object.keys(groups)
        .sort()
        .map(function (k) { return groups[k]; });
    }

    function findVariant() {
      var selected = currentOptions();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(Boolean);
        return selected.length === opts.length && selected.every(function (val, i) { return val === opts[i]; });
      });
    }

    function updateForSelection() {
      var variant = findVariant();
      if (!variant) return;
      if (variantSelect) variantSelect.value = variant.id;
      var priceCurrentEl = document.querySelector('#ProductPrice .pdp-price-current');
      var priceCompareEl = document.querySelector('#ProductPrice .pdp-price-compare');
      var priceDiscountEl = document.querySelector('#ProductPrice .pdp-price-discount');
      var addBtn = productForm.querySelector('[data-add-to-cart]');
      var addLabel = productForm.querySelector('[data-add-to-cart-label]');
      if (priceCurrentEl) {
        priceCurrentEl.textContent = formatMoney(variant.price);
      }
      var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceCompareEl) {
        priceCompareEl.style.display = hasDiscount ? '' : 'none';
        if (hasDiscount) priceCompareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (priceDiscountEl) {
        priceDiscountEl.style.display = hasDiscount ? '' : 'none';
        if (hasDiscount) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          priceDiscountEl.textContent = pct + '% off';
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      var stockEl = document.querySelector('[data-stock-label]');
      if (stockEl) {
        stockEl.textContent = variant.available ? 'In stock, ready to ship' : 'Currently out of stock';
        stockEl.classList.toggle('is-out', !variant.available);
      }
      if (variant.featured_image) {
        var mainImg = document.querySelector('#ProductMainImage img');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
    }

    function syncOptionLabels() {
      optionSelectors.forEach(function (input) {
        var label = input.closest('label');
        if (label) label.classList.toggle('is-selected', input.checked);
        if (input.checked) {
          var legendValue = input.closest('fieldset') && input.closest('fieldset').querySelector('legend .muted');
          if (legendValue) legendValue.textContent = input.value;
        }
      });
    }

    optionSelectors.forEach(function (input) {
      input.addEventListener('change', function () {
        syncOptionLabels();
        updateForSelection();
      });
    });
    syncOptionLabels();

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var addBtn = productForm.querySelector('[data-add-to-cart]');
      var addLabel = productForm.querySelector('[data-add-to-cart-label]');
      var errorEl = productForm.querySelector('[data-form-error]');
      var originalLabel = addLabel ? addLabel.textContent : '';
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }
      if (addLabel) addLabel.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add this item to your cart.');
            return data;
          });
        })
        .then(function (item) {
          trackAddToCart(item);
          return refreshCart();
        })
        .then(function () { openCartDrawer(); })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        })
        .then(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
          if (addLabel) addLabel.textContent = originalLabel;
        });
    });

    /* Buy it now / dynamic checkout buttons go straight to checkout */
    productForm.addEventListener('click', function (e) {
      if (e.target.closest('.shopify-payment-button')) {
        window.skmTrack('InitiateCheckout', { content_type: 'product' });
      }
    });
  }

  /* ---------- Sticky add-to-cart bar (product page, mobile) ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAddBtn = document.querySelector('#ProductForm [data-add-to-cart]');
  if (stickyBar && mainAddBtn && 'IntersectionObserver' in window) {
    var stickyBtnEl = stickyBar.querySelector('[data-sticky-atc-btn]');
    new IntersectionObserver(function (entries) {
      var offscreen = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', offscreen);
      stickyBar.setAttribute('aria-hidden', String(!offscreen));
      if (stickyBtnEl) stickyBtnEl.tabIndex = offscreen ? 0 : -1;
    }).observe(mainAddBtn);
  }

  /* ---------- Delivery estimate (business days from today) ---------- */
  var etaEl = document.querySelector('[data-delivery-eta]');
  if (etaEl) {
    var addBusinessDays = function (days) {
      var d = new Date();
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0) days--; // skip Sundays
      }
      return d;
    };
    var fmt = function (d) {
      return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    };
    var rangeEl = etaEl.querySelector('[data-eta-range]');
    if (rangeEl) {
      rangeEl.textContent = fmt(addBusinessDays(parseInt(etaEl.getAttribute('data-eta-min'), 10) || 3)) +
        ' and ' + fmt(addBusinessDays(parseInt(etaEl.getAttribute('data-eta-max'), 10) || 5));
      etaEl.hidden = false;
    }
  }

  /* ---------- Quick add (product cards) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.quick-add');
    var label = form.querySelector('[data-quick-add-label]');
    var original = label ? label.textContent : '';
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed (' + res.status + ')');
        return res.json();
      })
      .then(function (item) { trackAddToCart(item); return refreshCart(); })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); }
        if (label) label.textContent = 'Added';
        openCartDrawer();
        setTimeout(function () {
          if (btn) btn.classList.remove('is-added');
          if (label) label.textContent = original;
        }, 2000);
      })
      .catch(function (err) {
        console.error(err);
        if (btn) btn.classList.remove('is-loading');
        if (label) label.textContent = 'Unavailable';
        setTimeout(function () { if (label) label.textContent = original; }, 2000);
      });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  cartOpenBtns.forEach(function (btn) { btn.addEventListener('click', openCartDrawer); });
  cartCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCartDrawer();
    toggleMobileMenu(false);
  });

  /* ---------- Meta Pixel helpers ---------- */
  function trackAddToCart(item) {
    if (!item) return;
    window.skmTrack('AddToCart', {
      content_type: 'product',
      content_ids: [String(item.product_id)],
      content_name: item.product_title,
      value: (item.final_line_price || item.line_price || 0) / 100,
      currency: window.skm ? window.skm.currency : 'INR'
    });
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-checkout-button], button[name="checkout"]');
    if (cta) window.skmTrack('InitiateCheckout', { currency: window.skm ? window.skm.currency : 'INR' });
  });

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count === 0 ? 'none' : '';
        });
        document.querySelectorAll('[data-cart-count-inline]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return renderCartDrawer();
      });
  }

  function renderCartDrawer() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var body = document.querySelector('[data-cart-items]');
        var subtotal = document.querySelector('[data-cart-subtotal]');
        if (subtotal) {
          subtotal.textContent = formatMoney(cart.total_price);
        }
        if (body) {
          body.textContent = '';
          if (cart.item_count === 0) {
            var emptyMsg = document.createElement('p');
            emptyMsg.className = 'muted';
            emptyMsg.style.paddingBlock = '1.5rem';
            emptyMsg.textContent = 'Your cart is empty.';
            body.appendChild(emptyMsg);
          } else {
            cart.items.forEach(function (item, idx) {
              body.appendChild(buildCartLine(item, idx));
            });
          }
        }
      });
  }

  function buildCartLine(item, idx) {
    var line = document.createElement('div');
    line.className = 'cart-line';
    line.setAttribute('data-line-item', String(idx + 1));

    var link = document.createElement('a');
    link.href = item.url;
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image;
      img.alt = item.product_title || '';
      img.width = 80;
      img.height = 80;
      link.appendChild(img);
    }

    var info = document.createElement('div');
    info.style.flex = '1';
    info.style.minWidth = '0';

    var titleLink = document.createElement('a');
    titleLink.href = item.url;
    titleLink.className = 'product-card-title';
    titleLink.style.fontSize = '0.9375rem';
    titleLink.textContent = item.product_title;
    info.appendChild(titleLink);

    if (item.variant_title) {
      var variantEl = document.createElement('p');
      variantEl.className = 'type-micro';
      variantEl.style.marginTop = '0.25rem';
      variantEl.textContent = item.variant_title;
      info.appendChild(variantEl);
    }

    var row = document.createElement('div');
    row.style.display = 'flex';
    row.style.alignItems = 'center';
    row.style.justifyContent = 'space-between';
    row.style.marginTop = '0.625rem';

    var stepper = document.createElement('div');
    stepper.className = 'qty-stepper';
    stepper.innerHTML =
      '<button type="button" data-qty-decrease aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg></button>' +
      '<input type="number" min="0" data-qty-input aria-label="Quantity">' +
      '<button type="button" data-qty-increase aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg></button>';
    stepper.querySelector('input').value = item.quantity;

    var priceEl = document.createElement('span');
    priceEl.style.fontWeight = '700';
    priceEl.textContent = formatMoney(item.final_line_price);

    row.appendChild(stepper);
    row.appendChild(priceEl);
    info.appendChild(row);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'cart-remove';
    removeBtn.setAttribute('data-line-remove', '');
    removeBtn.textContent = 'Remove';
    info.appendChild(removeBtn);

    line.appendChild(link);
    line.appendChild(info);
    return line;
  }

  function formatMoney(cents) {
    var format = (window.skm && window.skm.moneyFormat) || '₹{{amount}}';
    var value = (cents / 100);
    function withDelimiters(number, precision, thousands, decimal) {
      var fixed = number.toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + thousands);
      return parts.join(parts[1] ? decimal : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, token) {
      switch (token) {
        case 'amount': return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }
})();
